import { render } from "./NavigationFullscreen.vue?vue&type=template&id=4d6e05a2"
import script from "./NavigationFullscreen.vue?vue&type=script&lang=js"
export * from "./NavigationFullscreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__